import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const StudentAuthContext = createContext({ student: undefined });

export function StudentAuthProvider({ children }) {
  const [student, setStudent] = useState(undefined); // undefined = checking, null = signed out

  const checkAuth = useCallback(async () => {
    try {
      const r = await api.get("/auth/session/me");
      setStudent(r.data);
    } catch {
      setStudent(null);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    // AuthCallback will exchange the session_id and establish the session first.
    if (window.location.hash?.includes("session_id=")) return;
    checkAuth();
  }, [checkAuth]);

  const signOut = async () => {
    await api.post("/auth/session/logout").catch(() => {});
    setStudent(null);
  };

  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const signInWithGoogle = () => {
    const redirectUrl = window.location.origin + "/profile";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <StudentAuthContext.Provider value={{ student, setStudent, signOut, signInWithGoogle, refresh: checkAuth }}>
      {children}
    </StudentAuthContext.Provider>
  );
}

export const useStudent = () => useContext(StudentAuthContext);
